import { EDUCATION_LIST, EDUCATION_ADDEDIT, EDUCATION_CHANGE_STATUS, EDUCATION_DELETE } from "../../api/constApi";
import { authHeader } from "./authHeader";
import { apiInstance } from "./axiosApi";


export const EducationListApi = (payload) => {
    return apiInstance.post(EDUCATION_LIST, payload, {
        headers: authHeader(),
    });
};

export const EducationChangeStatusApi = (payload) => {
    return apiInstance.post(EDUCATION_CHANGE_STATUS, payload, {
        headers: authHeader(),
    });
};

export const AddEditEducationApi = (payload) => {
    return apiInstance.post(EDUCATION_ADDEDIT, payload, {
        headers: authHeader(),
    });
};

export const educationDeleteApi = (payload) => {
    return apiInstance.post(EDUCATION_DELETE, payload, {
        headers: authHeader(),
    });
};